import { render, staticRenderFns } from "./AppDownloadDoucanDoctor.vue?vue&type=template&id=0e7b9332&scoped=true"
import script from "./AppDownloadDoucanDoctor.vue?vue&type=script&lang=js"
export * from "./AppDownloadDoucanDoctor.vue?vue&type=script&lang=js"
import style0 from "./AppDownloadDoucanDoctor.vue?vue&type=style&index=0&id=0e7b9332&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7b9332",
  null
  
)

export default component.exports